import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-dialog-advanced-function',
    imports: [MatDialogModule, MatButtonModule, TranslateModule],
    templateUrl: './dialog-advanced-function.component.html',
    styleUrl: './dialog-advanced-function.component.scss'
})
export class DialogAdvancedFunctionComponent implements AfterViewInit {

  constructor(
    public dialogRef: MatDialogRef<DialogAdvancedFunctionComponent>,
    private elementRef: ElementRef
  ) { }

  ngAfterViewInit() {

    // serve per aprire il link nel messaggio in una ltro tab
    const links: HTMLAnchorElement[] = this.elementRef.nativeElement.querySelectorAll('a');
    links.forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  }

}
